import React, { PureComponent } from 'react'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField'
// import { Rating } from 'material-ui-rating'
import Rating from '../Rating'
import { themeColors } from '../../styles/theme'

class FeedbackModal extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      feedback: 0,
      reason: '',
    }
  }

  render() {
    const { open, onRequestClose, onFeedback } = this.props
    const { feedback, reason } = this.state
    const validReason = !(feedback !== 0 && feedback <= 2 && !reason)
    const close = () => {
      this.setState({ feedback: 0, reason: '' })
      onRequestClose()
    }

    const actions = [
      <FlatButton label="Annulla" primary={true} onClick={close} />,
      <FlatButton
        label="Ok"
        disabled={this.state.feedback === 0 || !validReason}
        primary={true}
        keyboardFocused={true}
        onClick={() => {
          onFeedback(this.state.feedback, this.state.reason)
          close()
        }}
      />,
    ]
    return (
      <Dialog
        title="Feedback"
        titleStyle={{ backgroundColor: themeColors.lightBackground }}
        actions={actions}
        autoScrollBodyContent={true}
        modal={false}
        contentClassName="fullwidth-for-small"
        open={open}
        onRequestClose={close}>
        <div
          style={{
            textAlign: 'center',
            padding: '5px',
            color: themeColors.lightblack,
          }}>
          <div>Dai una valutazione allo scambio</div>
          <Rating
            onChange={feedback => this.setState({ feedback })}
            value={this.state.feedback}
          />
        </div>
        <TextField
          errorText={
            !validReason
              ? 'Per un feedback negativo è necessaria una motivazione'
              : undefined
          }
          value={reason}
          onChange={e => this.setState({ reason: e.target.value })}
          hintText="Motivazione"
          floatingLabelText="Motivazione"
          multiLine={true}
          fullWidth={true}
          rows={2}
        />
      </Dialog>
    )
  }
}

export default FeedbackModal



// WEBPACK FOOTER //
// ./src/common/Swap/FeedbackModal.js